import React, { FunctionComponent } from 'react';
import PropTypes from "prop-types";
import Input from "@murphy-frontend/web-core/components/Input";
import Textarea from "@murphy-frontend/web-core/components/TextArea";
import { CustomCheckbox } from '../../../common/components/MurphyCheckbox';
import Button from "@murphy-frontend/web-core/components/Button"
import ControlledFormSelect from "@murphy-frontend/web-core/components/MurphySelect/ControlledFormSelect"
import { Control } from "react-hook-form";
import { EventFlowTemplateFormDto } from "../CreateEventFlowTEmplate";

interface IncidentBasicInformationFilterProps {
  onAddPermissions: () => boolean;
  onConfirmBeforeStart: () => boolean;
  onGeoLocation: () => boolean;
  translations?: Record<string, string>;
  name: string;
  description: string;
  alertTemplateOptions: {value: number; label: string}[];
  confirmbeforestartIsChecked: boolean;
  geolocationIsChecked: boolean;
  addpermissionsIsChecked: boolean;
  enable: boolean;
  handleNameChange: any;
  handleDescriptionChange: any;
    control: Control<EventFlowTemplateFormDto>;
}

const styles = {
  row: {
    display: 'flex',
    width: '80rem'
  },
  input: {
    borderWidth: 1,
    borderColor: '#EBEBEB',
    borderStyle: 'solid',
    borderRadius: 5,
    width: '60rem'
  },
  label: {
    width: '10rem',
    color: '#626262'
  },
  required: {
    width: '10rem',
    color: '#626262',
    fontSize: 10,
    fontStyle: 'italic'
  }
}


	const colors = [
		{value: 1, label: "Red"},
		{value: 2, label: "Blue"},
		{value: 3, label: "Green"}
	]
  
const IncidentBasicInformation: FunctionComponent<
  IncidentBasicInformationFilterProps> = ({
      control,
    onAddPermissions,
    onConfirmBeforeStart,
    onGeoLocation,
  name,
  description,
  	alertTemplateOptions,
  confirmbeforestartIsChecked,
  geolocationIsChecked,
  addpermissionsIsChecked,
  enable,
  translations,
  handleNameChange,
  handleDescriptionChange

}) => {
  return (
  <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 20, paddingRight: 20, marginTop: 20 }}>
      <div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations.name}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>

        <Input
          val={name}
          isRequired
          style={styles.input}
           handleChange={handleNameChange}
          // errorMessage={messageBodyError}
        />
      </div>

      <div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations["class-lang-modal-description"] || "Description"}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>
        <Textarea
          title={""}
          val={description}
          style={styles.input}
          isRequired
           handleChange={handleDescriptionChange}
          // errorMessage={messageBodyError}
          rows={3}
          cols={1}
          placeholder={translations.tmpMaxchars100 || "Max 100 characters..."}
        />
      </div>
      				<ControlledFormSelect
							control={control}
							title= {translations.tmpColor || 'Color'}
							name='Type'
							label='Color'
							options={colors}
							isMulti={false}
						/>

						<ControlledFormSelect
							control={control}
							title= {translations.tmpAlertOnIncidetStart || 'Alert Template On Start Event'}
							name='AlertTemplateId'
							label='Alert Template'
							options={alertTemplateOptions}
							isMulti={false}
						/>
                              <div className='flex-row-container vertical-aligner left-aligner margin-top-20'>
                        <CustomCheckbox
                          onChange={onGeoLocation}
                          checked={geolocationIsChecked}
                          checkedColor="#00A098"
                          unCheckedColor="#7F7F7F"
                            />
                              <label style={{color: 'grey', width: '30rem', fontSize: 14}}>{translations.tmpgeolocation || "Ask user to send geo location on incident start"}</label>
                        </div>
                        <br></br>
                             <div className='flex-row-container vertical-aligner left-aligner margin-top-20'>
                       <CustomCheckbox
                              onChange={onConfirmBeforeStart}
                              checked={confirmbeforestartIsChecked}
                              checkedColor="#00A098"
                              unCheckedColor="#7F7F7F"
                                />
                              <label style={{color: 'grey', width: '30rem', fontSize: 14}}>{translations.tmpconfirmbeforestart || "Ask user for confirmtion that it ment to start incident before start"}</label>
                        </div>
                        <br></br>
                             <div className='flex-row-container vertical-aligner left-aligner margin-top-20'>
                                <CustomCheckbox
                                  onChange={onAddPermissions}
                                  checked={addpermissionsIsChecked}
                                  checkedColor="#00A098"
                                  unCheckedColor="#7F7F7F"
                                />
                              <label style={{color: 'grey', width: '30rem', fontSize: 14}}>{translations.tmpaddpermisson || "Add permissions, only users with permission will se the incident"}</label>
                        </div>

    </div>
  );
};

export default IncidentBasicInformation;
